import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Switch } from "@mui/material";

// import JS files
import RemoveModal from "../../../shares/RemoveModal";
import ProducerInfoModal from "./ProducerInfoModal";
import useFetch from "../../../../context/useFetch";
import EditProducer from "./EditProducer";
import MuiButton from "../../../shares/MuiButton";
import { useUserData } from "../../../../context/UserDataContext";

// import Others files

const ProducerCard = (props) => {
  const [id, seId] = useState(props.userId);
  const [userUserName,setUserUserName] = useState();

  const [openInfoProducerModal, setOpenInfoProducerModal] = useState(false);
  const handleModal = () => {
    setOpenInfoProducerModal((before) => !before);
  };

  const [openEditProducerCard, setOpenEditProducerCard] = useState(false);
  const handleEditProducerModal = () => {
    setOpenEditProducerCard((before) => !before);
  };

  const [openRemoveProducerCard, setOpenRemoveProducerCard] = useState(false);
  const handleRemoveCustomerModal = () => {
    setOpenRemoveProducerCard((before) => !before);
  };

  const [openRemoveProfilePicModall, setOpenRemoveProfilePicModal] =
    useState(false);

  const delete_message = (itemKey) => {
    setUserUserName(itemKey);
    setOpenRemoveProfilePicModal(!openRemoveProfilePicModall);
  };

  const deleteProfilePicApi = useFetch({
    method: "get",
    url: `User_Service/${userUserName}/delete_image`,
    trigger: false,
    argFunc: () => {
      props.getFunc.reFetch();
      setOpenRemoveProfilePicModal(!openRemoveProfilePicModall);
      // setSendMessage("");
      // setAttachFile(null);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm();

  const deleteProviderApi = useFetch({
    method: "delete",
    url: `Provider_Service/${id}`,
    argFunc: (res) => {
      props.getFunc.reFetch();
      // toast.success("کاربر موردنظر با موفقیت حذف شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [canCreateOrder, setCanCreateOrder] = useState();
  const handle_switch_change = (event) => {
    setCanCreateOrder(event.target.checked);
  };

  return (
    <>
      {openInfoProducerModal && (
        <ProducerInfoModal
          openModal={openInfoProducerModal}
          setOpenModal={setOpenInfoProducerModal}
          name={props.name}
          phone_number={props.phone_number}
          attach_file={props.attach_file}
          brand={props.brand}
          address={props.address}
          city={props.city}
          email={props.email}
          phone={props.phone}
          user={props.user}
          code={props.code}
          UserId={props.userId}
        />
      )}

      {openEditProducerCard && (
        <EditProducer
          openModal={openEditProducerCard}
          setOpenModal={setOpenEditProducerCard}
          name={props.name}
          phone_number={props.phone_number}
          attach_file={props.attach_file}
          // brand={props.brand}
          bangle={props.bangle}
          address={props.address}
          city={props.city}
          email={props.email}
          phone={props.phone}
          user={props.user}
          code={props.code}
          userId={props.userId}
          getFunc={props.getFunc}
        />
      )}
      {openRemoveProducerCard && (
        <RemoveModal
          openModal={openRemoveProducerCard}
          setOpenModal={setOpenRemoveProducerCard}
          onClick={() => deleteProviderApi.reFetch()}
          text="آیا از حذف تولیدکننده موردنظر اطمینان دارید؟"
        />
      )}
      <div className="panel-card">
        <div className="group flex flex-col items-center justify-center mb-8">
          <img
            className="w-28 h-28 md:w-40 md:h-40 rounded-full"
            src={props.attach_file}
          />
          <div className="hidden group-hover:block mt-3 mr-2">
            <DeleteIcon
              className="close-modal-icon"
              onClick={() => delete_message(props.key)}
            />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <span className="show-label	">
            نام: <span className="show-value"> {props.name} </span>
          </span>
          <span className="show-label">
            کد استاندارد: <span className="show-value">{props.code}</span>
          </span>
        </div>

        <div className="flex items-center justify-between mt-6">
          <MuiButton
            onClick={handleModal}
            variant="outlined"
            // icon={<AddIcon />}
            color="secondary"
            text="اطلاعات بیشتر"
          />

          <div className="flex items-center">
            <span className="text-xs md:text-sm">ثبت سفارش:</span>
            <Switch onChange={handle_switch_change} checked={canCreateOrder} />
          </div>
        </div>

        <div className="flex justify-between mt-6">
          <div className="edit-icon">
            <EditIcon onClick={() => handleEditProducerModal()} />
          </div>

          <div
            className="delete-icon"
            onClick={() => handleRemoveCustomerModal()}
          >
            <DeleteIcon />
          </div>
        </div>
        {openRemoveProfilePicModall && (
          <RemoveModal
            openModal={openRemoveProfilePicModall}
            setOpenModal={setOpenRemoveProfilePicModal}
            onClick={() => deleteProfilePicApi.reFetch()}
            text="آیا از حذف عکس پروفایل کاربر موردنظر اطمینان دارید؟"
          />
        )}
      </div>
    </>
  );
};

export default ProducerCard;
